const pixelsCategories = ["PERFORMANCE","TARGETING","STRICTLY_NECESSARY"];

export { pixelsCategories };